
import { FormGroup } from '@angular/forms';

export class CustomValidators {
    static multipleCheckboxRequireOne(fb: FormGroup) {
        const fields = [];
        for (let field in fb.controls) {
            fields.push(fb.controls[field]);
        }

        if (!fields.some(control => control.value && control.value !== '')) {
            return {
                multipleCheckboxRequireOne: true
            };
        }

        return null;
    }
}
